// extracted by mini-css-extract-plugin
module.exports = {"coupon-carousel":"CouponCarousel_coupon-carousel__vFSRE","coupon-carousel__coupon":"CouponCarousel_coupon-carousel__coupon__kB7nu"};